import { create } from 'zustand';
import type { IOfferConsentPartner } from '@/@types/health/offers';

export interface NotificationConfig {
    /** "devis" | "souscription" | "rappel" — completes "Votre demande de … a bien été reçue." */
    text: string;
    /** Filename inside /public/assets/health/companies/square (e.g. "magnolia.png").
     *  Falls back to a generic logo if missing. */
    image?: string;
    /** Offer's partner as served by the API; always named by the popup, callback number appended only when it has one. */
    partner?: IOfferConsentPartner | null;
    useLandingImage?: boolean;
    /** Second action or more: the partner is announced as the fallback of the first one. */
    followUp?: boolean;
    /** Mercer's named wording, honoured on the first request only: a followUp announces Mercer like any other partner. */
    conseiller?: { name: string; phone: string };
}

interface PopupNotificationState {
    notification: NotificationConfig | null;
    showNotification: (config: NotificationConfig) => void;
    hideNotification: () => void;
}

export const usePopupNotificationStore = create<PopupNotificationState>((set) => ({
    notification: null,
    showNotification: (config) => set({ notification: config }),
    hideNotification: () => set({ notification: null }),
}));
